import { Component, useEffect, useState } from 'react';
import { ArrowsClockwise, WarningCircle } from '@phosphor-icons/react';

export function PageLoading({ label = 'workspace' }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), 10000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="page-state" role="status" aria-live="polite">
    <p className="page-state__label">{slow ? 'This is taking longer than expected.' : `Opening ${label}…`}</p>
    <div className="page-state__skeleton" aria-hidden="true"><i /><i /><div><i /><i /><i /></div></div>
    {slow && <button onClick={() => window.location.reload()}><ArrowsClockwise size={16} /> Reload page</button>}
  </div>;
}

export class PageBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error('CUZO page failed to render', error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <section className="page-state page-state--error" role="alert">
      <WarningCircle size={28} />
      <h2>This section couldn’t open</h2>
      <p>The page failed to load. You can reload it or use the navigation to open another section.</p>
      <button onClick={() => window.location.reload()}><ArrowsClockwise size={16} /> Reload page</button>
    </section>;
  }
}
